<template>
  <b-modal
    :id="`update-password-${user_data.id}`"
    content-class="rounded-xl"
    size="lg"
    hide-footer
    scrollable
    :title="`Update User Password: ${user_data.name || ''} - ${user_data.email || ''}`"
    @show="resetModels"
  >
    <ValidationObserver v-slot="{ handleSubmit }" ref="baseForm">
        <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off">
            <b-row>
                <b-col cols="12" lg="12">
                    <s-input
                    v-model="mainData.old_pass"
                    :item="{
                        label: 'Password Lama',
                        type: 'password',
                        validation: [],
                        placeholder: 'Masukan Password Lama',
                    }"
                    ></s-input>
                </b-col>
                <b-col cols="12" lg="12">
                    <s-input
                    v-model="mainData.new_pass"
                    :item="{
                        label: 'Password Baru',
                        type: 'password',
                        validation: [],
                        placeholder: 'Masukan Password Baru',
                    }"
                    ></s-input>
                </b-col>
                <b-col cols="12" lg="12">
                    <s-input
                    v-model="mainData.confirmation_pass"
                    :item="{
                        label: 'Konfirmasi Password Baru',
                        type: 'password',
                        validation: [],
                        placeholder: 'Masukan Password Baru',
                    }"
                    ></s-input>
                </b-col>
            </b-row>
            <b-row class="mx-0 animated">
            <b-btn variant="primary" class="mr-2" type="submit">
                <i class="ri-save-line"></i>
                Update Password
            </b-btn>
            <b-btn
                @click="$bvModal.hide(`update-password-${user_data.id}`)"
                variant="light-primary"
            >
                Batal
            </b-btn>
            </b-row>
        </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import axios from "axios";
import mode from "@/mode.js";
export default {
  name: "UpdateUserPassword",
  components: {
  },

  props: {
    isShowed: {
      type: Boolean,
      default: false,
    },
    user_data: {
      type: Object,
      required: true,
    },
  },

  computed: {
  },

  data() {
    return {
      isLoading: false,
      mainData: {
        old_pass: null,
        new_pass: null,
        confirmation_pass: null,
      }
    };
  },

  mounted() {
    this.mainData = {};
  },

  methods: {
    resetModels() { 
        this.mainData = {};
    },
    onSubmit: async function () {
      const routeParam = this.$route.query; 
      try {
        const confirm = await this.$_alert.confirm(
          "Update Password?",
          "Pastikan Password Susah Ditebak dan Mudah Untuk Anda Ingat!"
        );
        if (!confirm.isConfirmed) return;
        // console.log('pass config',this.mainData)
        const payload = {...this.mainData, user_id: this.user_data.id};
        axios
          .post(`${this.$_config.server[mode]}/change_password`, payload)
          .then((res) => {

            this.$_alert.success(this.$t("password_change.success"));
            console.log('password changed', res);

          })
          .catch((err) => {
            this.isLoading = false;
            this.$_alert.error(err);
          });
          this.$emit('successfuly-update-password');
        } catch (err) {
          console.log("onSubmit() error", err);
          this.$_alert.error(err);
        } finally {
        this.$bvModal.hide(`update-password-${this.user_data.id}`);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/modules/profile/components/change-password.vue